console.log("#### bootstrap.js ####")

import $ from  "jquery";
window.$ = window.jQuery = $;
import * as Bootstrap from  "../node_modules/bootstrap/dist/js/bootstrap.bundle.js";
//import $ from  "jquery";
import Masonry from "masonry-layout";
window.Masonry = Masonry;
//window.$ = window.jQuery = $;
import Alpine from "alpinejs";
window.Alpine = Alpine;
window.Bootstrap = Bootstrap;

